import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

class Breadcrumb extends Component {
  render() {
    let items = [];
    for (const step of this.props.stepList) {
      items.push(step);
      if (this.props.currentStep === step.name) {
        break;
      }
    }

    return (
      <nav aria-label="breadcrumb" className="container pl-0">
        <ol className="breadcrumb">
          {items.map(step => (
            <li
              key={step.name}
              className={
                this.props.currentStep === step.name
                  ? "breadcrumb-item active"
                  : "breadcrumb-item"
              }
              aria-current="page"
            >
              {this.props.currentStep === step.name ? (
                step.label
              ) : (
                <Link to={step.route}>{step.label}</Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    );
  }
}

Breadcrumb.propTypes = {
  stepList: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentStep: PropTypes.string.isRequired
};

export default Breadcrumb;
